/**
 * eslint-disable no-unused-vars
 *
 * @format
 */

import React, { useState } from "react";
import { useRef } from "react";
import { Container, Typography, TextField, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";
import "./Contact.css";
import { POST_COMMENT_FAIL } from "../../constants/notesConstants";
import { useDispatch, useSelector } from "react-redux";
import { getSocialLinks } from "../../action/notesActions";
import { toast } from "wc-toast";
import img from "./../../assets/s.gif";
import axios from "axios";
import { useEffect } from "react";
import { getObject } from "../../utils/getName";

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: "100vw",
    marginTop: "3em",
    marginBottom: "3em",
  },
  form: {
    width: "100%",
  },
  formfield: {
    width: "100%",
    marginBottom: "2rem",
  },
}));

export const Contact = () => {
  const classes = useStyles();

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [comments, setComments] = useState("");
  const [error, setError] = useState(null);
  const [success, setSucces] = useState(false);

  const dispatch = useDispatch();

  const social = useSelector((state) => state.SocialLinks);
  const { socialLinks } = social;

  const greetings = "Say hello.";

  const form = useRef();
  const resetHandler = () => {
    setFullName("");
    setEmail("");
    setComments("");
  };

  useEffect(() => {
    // get();
    dispatch(getSocialLinks());
  }, [dispatch]);

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      if (!fullName || !comments) {
        setError("Empity Filds");
        return dispatch({
          type: POST_COMMENT_FAIL,
          payload: "Empity Filds",
        });
      } else if (!isValidEmail(email)) {
        setError("Email is invalid");
        return toast.error(error, { duration: 3000 });
      } else {
        setError(null);
      }
      toast.loading("Loading ...", { duration: 3000 });

      const { data } = await axios.post(
        "https://portfolio-api-v001.vercel.app/api/comment/64d8ace7233c63d92a59a7c3",
        {
          fullName,
          email,
          comments,
        }
      );

      // const { data } = await axios.post(url.API_URI + "comment", {
      //   fullName,
      //   email,
      //   comments,
      // });
      console.log(data);

      setSucces(true);
      toast.success("Comment Submited successfully", { duration: 3000 });
      e.target.reset();
      resetHandler();
      setTimeout(() => {
        setSucces(null);
      }, 3000);
    } catch (error) {
      console.log(error);
      let message = "";
      if (error.response) {
        if (error.response.data) {
          if (error.response.data[0]) {
            if (error.response.data[0].errors.fullName?.message) {
              message = error.response.data[0].errors.fullName?.message;
            } else if (error.response.data[0].errors.email?.message) {
              message = error.response.data[0].errors.email?.message;
            } else if (error.response.data[0].errors.comments?.message) {
              message = error.response.data[0].errors.comments?.message;
            }
          } else if (error.response.data.msg) {
            if (error.response.data.msg.message) {
              message = error.response.data.msg.message;
              console.log(error.response.data.msg.message);
            } else {
              message = error.response.data.msg;
            }
          } else {
            message = error.response.data;
          }
        } else {
          message = error.response;
        }
      } else {
        message = error.message;
      }

      setError(message);
      toast.error(message, { duration: 4000 });
      // console.log(error);
    }
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  return (
    <section id="contact">
      {success && (
        <div className="suc">
          <img src={img} alt="" srcset="" />
        </div>
      )}

      <Container component="main" className={classes.main} maxWidth="md">
        <div className="contact">
          <h1 className="contact_msg">
            <TextDecrypt text={greetings} />
          </h1>

          <div className="_form_wrapper">
            <form ref={form} onSubmit={submitHandler} className={classes.form}>
              {!isValidEmail(email) && (
                <p className="error-message" style={{ color: "red" }}>
                  {error ? error : "Email is required"}
                </p>
              )}{" "}
              {error && (
                <div className="error-message" style={{ color: "red" }}>
                  {error}
                </div>
              )}
              <TextField
                id="outlined-name-input"
                label="Name"
                type="text"
                size="small"
                variant="filled"
                name="name"
                className={classes.formfield}
                onChange={(e) => setFullName(e.target.value)}
              />
              <TextField
                id="outlined-password-input"
                label="Email"
                type="email"
                size="small"
                variant="filled"
                name="email"
                className={classes.formfield}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                id="outlined-password-input"
                label="Message"
                type="textarea"
                size="small"
                multiline
                minRows={5}
                variant="filled"
                name="message"
                className={classes.formfield}
                onChange={(e) => setComments(e.target.value)}
              />
              <button
                // disabled={error ? true : false}
                type="submit"
                value="Send"
                className="submit-btn"
              >
                <i className="fas fa-terminal"></i>
                <Typography component="span"> Send Message</Typography>
              </button>
            </form>
          </div>
        </div>
      </Container>

      <div _ngcontent-serverapp-c25="" class="padding grid">
        <div _ngcontent-serverapp-c25="" class="header-text">
          <h1 _ngcontent-serverapp-c25="">Contact Information</h1>
          <p _ngcontent-serverapp-c25="">
            Fiil up the form and I will get back to you within 24 hours or use
            this options 👇👇👇👇
          </p>
        </div>
        <ul _ngcontent-serverapp-c25="" class="contact-address grid">
          {getObject(socialLinks, "phone")?.status && (
            <li _ngcontent-serverapp-c25="">
              <a
                target="_blank"
                href={`tel:${getObject(socialLinks, "phone")?.link}`}
              >
                📞{getObject(socialLinks, "phone")?.link}
              </a>
            </li>
          )}
          {getObject(socialLinks, "email")?.status && (
            <li _ngcontent-serverapp-c25="">
              <a
                _ngcontent-serverapp-c25=""
                target="_blank"
                href={`mailto:${
                  getObject(socialLinks, "email")?.link
                }?subject=subject text`}
              >
                ✉️ Send Email
              </a>
            </li>
          )}
          {getObject(socialLinks, "web1")?.status && (
            <li _ngcontent-serverapp-c25="">
              <a target="_blank" href={getObject(socialLinks, "web1")?.link}>
                🌐 Yeabsira 1st
              </a>
            </li>
          )}
          {getObject(socialLinks, "web2")?.status && (
            <li _ngcontent-serverapp-c25="">
              <a target="_blank" href={getObject(socialLinks, "web2")?.link}>
                {/* <a href="#"> */}
                🌐 Yeabsira 2nd
              </a>
            </li>
          )}
        </ul>
      </div>
    </section>
  );
};
